function tabs() {
  const block = document.querySelector('.st-tabs:not(.static)');
  if (block) {
    const tabs = block.querySelectorAll('.st-tab');
    const contents = block.querySelectorAll('.content-tab');
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        tabs.forEach(e => {
          e.classList.remove('active');
        })
        contents.forEach(e => {
          e.classList.remove('active');
        })
        block.querySelector(`#tab${i + 1}`).classList.add('active');
        block.querySelector(`#ctab${i + 1}`).classList.add('active');
      })
    })
  }
}

tabs();